// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3VL2g","file":"styles_file__mIP19"};